import { InfoCircleOutlined, LoadingOutlined } from "@ant-design/icons";
import {
  ConfigProvider,
  DatePicker,
  Drawer,
  Radio,
  RadioChangeEvent,
  Select,
} from "antd";
import React, { useEffect, useState } from "react";
import { useSelector } from "react-redux";
import { getProduct, getThread } from "../redux/selectors";
import { getFeedFilter } from "../redux/selectors/feed-filter.selectors";
import DoughnutChart from "./DoughnutChart";
import locale from "antd/es/date-picker/locale/ru_RU";
import { summaryService } from "../api";

const CityDonut: React.FC = () => {
  const thread = useSelector(getThread);
  const feedFilter = useSelector(getFeedFilter);
  const [value, setValue] = useState("today");
  const [loading, setLoading] = useState(true);
  const { RangePicker } = DatePicker;
  const [total, setTotal] = useState(0);
  const [dataArr, setDataArr] = useState([]);
  const [city, setCity] = useState("Санкт-Петербург");
  const [cities, setCities] = useState([]);
  const product = useSelector(getProduct);
  const [dateString, setDateString] = useState([
    feedFilter.from,
    feedFilter.to,
  ]);
  const options = [
    { label: " Другое", value: "period" },
    { label: "Сегодня", value: "today" },
    { label: "7д", value: "week" },
    { label: "1м", value: "month" },
  ];
  const [open, setOpen] = useState(false);

  useEffect(() => {
    setLoading(true);
    let params = {
      product_id: product,
    };
    if (thread) {
      summaryService
        .loadProductCityList(params)
        .then((resp) => {
          let arr = [];
          setCities(
            resp.map(
              (it: any, id: number) =>
                (arr[id] = { label: it.city, value: it.city })
            )
          );
          setLoading(false);
        })
        .catch((error) => {
          console.log(error);
        });
    }
  }, [thread, product]);

  useEffect(() => {
    setLoading(true);
    if (thread) {
      let params = {
        product_id: product,
        city: city,
      };
      summaryService
        .loadCityReport(params)
        .then((resp) => {
          let summ: any =
            Number(resp.users_city) +
            Number(resp.other_cities_users) +
            Number(resp.users_undefined);
          let arr: any = [
            resp.users_city,
            resp.other_cities_users,
            resp.users_undefined,
          ];
          setTotal(summ);
          setDataArr(arr);
          setLoading(false);
        })
        .catch((error) => {
          console.log(error);
        });
    }
  }, [thread, city, product]);

  const showDrawer = () => {
    setOpen(true);
  };

  const onClose = () => {
    setOpen(false);
  };

  const onChange = ({ target: { value } }: RadioChangeEvent) => {
    setValue(value);

    if (value == "today")
      setDateString([
        new Date().toJSON().split("T")[0],
        new Date().toJSON().split("T")[0],
      ]);
    if (value == "week") {
      const start = new Date();
      start.setDate(start.getDate() - 6);
      setDateString([
        start.toJSON().split("T")[0],
        new Date().toJSON().split("T")[0],
      ]);
    }
    if (value == "month") {
      const start = new Date();
      start.setDate(start.getDate() - 29);
      setDateString([
        start.toJSON().split("T")[0],
        new Date().toJSON().split("T")[0],
      ]);
    }
  };

  const onPeriodChange = (value: any, dateString: string[]): void => {
    setDateString(dateString);
  };

  return (
    <div className="white-block-small">
      <div className="">
        <p className="block-title">
          Геолокация подписчиков
          <InfoCircleOutlined className="info" onClick={showDrawer} />
        </p>
        <div className="flex">
          <Select
            value={city}
            onChange={(e) => setCity(e)}
            style={{ width: 250 }}
            allowClear={false}
            options={cities}
            showSearch
          />
        </div>
      </div>
      {loading ? (
        <div className="feed-posts-loader" style={{ height: "300px" }}>
          <LoadingOutlined />
        </div>
      ) : total == 0 ? (
        <div className="feed-posts-loader" style={{ height: "300px" }}>
          Данных пока нет
        </div>
      ) : (
        <div>
          <DoughnutChart
            labelsArr={[
              `${city}`,
              "подписчики из других городов",
              "подписчики с не указанным городом",
            ]}
            dataArr={dataArr}
            summ={total}
          />
          <div className="legend-string">
            <div className="legend-square_1"></div>
            <p>{city}</p>
            <b>{((dataArr[0] * 100) / total).toFixed(2)}%</b>
          </div>

          <div className="legend-string">
            <div className="legend-square_2"></div>
            <p>подписчики из других городов</p>
            <b>{((dataArr[1] * 100) / total).toFixed(2)}%</b>
          </div>
          <div className="legend-string">
            <div className="legend-square_3"></div>
            <p>подписчики с не указанным городом</p>
            <b>{((dataArr[2] * 100) / total).toFixed(2)}%</b>
          </div>
        </div>
      )}
      <Drawer title="Что отображает этот график?" onClose={onClose} open={open}>
        <p className="purple-border">
          График демонстрирует геолокацию активной аудитории, взаимодействующей
          с публикациями (оставляют реакции: комментарии, лайки, репосты) за
          выбранный период
        </p>
        <p className="gray-block">
          <p className="gray-title">ПРИМЕЧАНИЕ</p>Данные обновляются в реальном
          времени, что позволяет вам следить за актуальными трендами и реакцией
          аудитории на ваш контент
        </p>
      </Drawer>
    </div>
  );
};

export default CityDonut;
